import helper from "@/urls/helper";

import {
  sendPostRequest,
  sendPatchRequest,
  sendDeleteRequest,
  sendGetRequest,
  finalizeRequest,
  makePostRequestFile
} from "@/helper/requests";
import surveys from "@/urls/roles/admin";
import creator from "@/urls/roles/creator";

const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  // ADMIN
  loadStageList: ({commit}, {survey_id, finalizer, catcher}) => {
    /**
     * Загружает список этапов для конкретного опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendGetRequest(
      surveys.ADMIN.STAGE.LIST(survey_id,{'size': 100}), finalizer, catcher
    )
  },
  createStage: ({commit}, {data, survey_id, finalizer, catcher}) => {
    /**
     * Создает новый этап для опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для создания этапа
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendPostRequest(
      surveys.ADMIN.STAGE.SAVE(survey_id), data, finalizer, catcher
    )

  },
  updateStage: ({commit}, {data, survey_id, finalizer, catcher}) => {
    /**
     * Обновляет существующий этап
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Обновленные данные этапа
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendPatchRequest(
      surveys.ADMIN.STAGE.EDIT(survey_id, data.id), data, finalizer, catcher
    )

  },
  copyStage: ({commit}, {survey_id, stage_id, finalizer, catcher}) => {
    /**
     * Копирует существующий этап
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа для копирования
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.STAGE.COPY(survey_id, stage_id,)
    sendGetRequest(url,
        (data) => {
          if (finalizer) finalizer(data)
        },
        (error_data) => {
          if (catcher) catcher(error_data)
        }
    )
  },
  deleteStage: ({dispatch, commit}, {survey_id, stage_id, finalizer, catcher}) => {
    /**
     * Удаляет этап
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendDeleteRequest(
      surveys.ADMIN.STAGE.DELETE(survey_id, stage_id), finalizer, catcher
    )

  },
  listStageField: ({commit}, {survey_id, stage_id, finalizer, catcher}) => {
    /**
     * Загружает список полей для конкретного этапа
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendGetRequest(
      surveys.ADMIN.STAGE_FIELDS.LIST(survey_id, stage_id, {'size': 100}), finalizer, catcher
    )
  },
  addStageField: ({commit}, {survey_id, stage_id, data, finalizer, catcher}) => {
    /**
     * Добавляет новое поле к этапу
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа
     * @param {Object} data - Данные для создания поля
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendPostRequest(
      surveys.ADMIN.STAGE_FIELDS.CREATE(survey_id, stage_id), data, finalizer, catcher
    )
  },
  updateStageField: ({state, commit}, {data, survey_id, stage_id, finalizer, catcher}) => {
    /**
     * Обновляет поле этапа
     * @param {Object} state - Состояние модуля
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Обновленные данные поля
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if(data.file !== undefined && data.file !== null && data.file.get_params === undefined) {
      let file = data.file
      let formData = new FormData()
      for (let el in data){
        if (data[el] === null) break
        else formData.append(`${el}`, data[el])
      }
      if (typeof file === 'object' && file !== null)
        if (String(file.name).length < 130 )
          formData.append('file', file)

      finalizeRequest(
        makePostRequestFile(
          surveys.ADMIN.STAGE_FIELDS.EDIT(survey_id, stage_id, data.id),
          formData,
          'PATCH'
        ),
        finalizer,
        catcher
      )
    } else {
      let send = {...data}
      if(data.file !== undefined && data.file !== null){
        delete send.file;
      }
      sendPatchRequest(
        surveys.ADMIN.STAGE_FIELDS.EDIT(survey_id, stage_id, data.id), send, finalizer, catcher
      )
    }
  },
  deleteStageField: ({dispatch, commit}, {survey_id, stage_id, id, finalizer, catcher}) => {
    /**
     * Удаляет поле из этапа
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа
     * @param {number} id - Идентификатор поля для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendDeleteRequest(
      surveys.ADMIN.STAGE_FIELDS.DELETE(survey_id, stage_id, id), finalizer, catcher
    )
  },
  updateStageFields: ({dispatch, commit}, {fields, survey_id, stage_id}) => {
    /**
     * Массово обновляет поля этапа
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Array} fields - Массив полей для обновления
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} stage_id - Идентификатор этапа
     */
    fields.forEach((el) => {
      dispatch(
        'updateStageField',
        {
          data: el,
          survey_id: survey_id,
          stage_id: stage_id,
          id: el.id
        }
      )
    })
  }
}


export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
